import { Row, Col, Card, ButtonGroup, Form, Collapse } from "react-bootstrap";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { getCenters } from "../../../../actions/CenterActions";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import LoadingOverlay from 'react-loading-overlay';
import 'react-widgets/dist/css/react-widgets.css';
import docs from "../../../../config/docs";
import { Info } from "@material-ui/icons";
import React, { Component } from "react";
import { IconButton } from "material-ui";
import { connect } from "react-redux";
import "./StadisticComponent.scss";
import Axios from "axios";
// Snack bar
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const buttonDisabled = {
	opacity: 0.5
};

const URL = docs.docsReports;

function defaultTime(date) {
	date = new Date(date.setDate(date.getDate() - 30));
	let month = Number(date.getMonth() + 1)
	month = (month > 9) ? month : '0' + (month)
	let day = Number(date.getDate())
	day = (day > 9) ? day : '0' + (day)
	let startDate = date.getFullYear() + '-' + month + '-' + day;
	return startDate
}
function formatTime(date) {
	let month = Number(date.getMonth() + 1)
	month = (month > 9) ? month : '0' + (month)
	let day = Number(date.getDate())
	day = (day > 9) ? day : '0' + (day)
	return (date.getFullYear() + '-' + month + '-' + day);
}


class Statistics extends Component {

	constructor(props) {
		super(props);
		this.state = {
			hide_branches:                   true,
			hide_vend:                       true,
			tabIndex:                        0,
			activeLoader:                    true,
			startDate:                       defaultTime(new Date()),
			finalDate:                       formatTime(new Date()),
			usuario:                         0,
			ventasMonto:                     0,
			ventasTotal:                     0,
			sucursales:                      0,
			frecuenciaVentas:                0,
			users_and_device:                0,
			average_tickets:                 0,
			users_registered:                0,
			users_with_at_least_one_purchase:0,
			encuestas:                       0,
			products_out_stock:              0,
			sold_products:                   0,
			searches:                        0,
			most_sold_products:              0,
			average_ticket_line:             0,
			branches:                        [],
			vend:                            ['IOS', 'ANDROID', 'ECOMMERCE'],
			// snack
			showSnackBar:                    false,
			textSnackBar:                    '',
			severitySnackBar:                'success',
		}
		this.handleClick     = this.handleClick.bind(this);
		this.handleClickVend = this.handleClickVend.bind(this);
	}

	componentDidMount() {
		this.props.getCenters(1, 200);
		this.setState({ centros: this.props.centros.centros })
		setTimeout(() => {
			this.setState({
				activeLoader: false
			});
		}, 2000)

	}

	componentDidUpdate(prevProps) {}

	///---------------------------------------EVENTS-------------------------------------
	onChangeStartDate(e) {
		this.setState({
			startDate: e.target.value,
		});
		const resp = this.validateDateRange(e.target.value, this.state.finalDate);
		if (resp === false) {
			this.setFinalDateOfTheRange();
		}
	}

	onChangeFinalDate(e) {
		const resp = this.validateDateRange(this.state.startDate, e.target.value);
		if (resp === true) {
			this.setState({
				finalDate: e.target.value,
			});
		} else {
			this.setFinalDateOfTheRange();
		}
	}

	validateDateRange(initialDate, finalDate) {
		const deadline = new Date(initialDate);
		let isValid    = false;
		deadline.setFullYear(deadline.getFullYear()+1);
		if (Date.parse(finalDate) <= Date.parse(deadline)){
			isValid = true;
		}
		return isValid;
	}

	setFinalDateOfTheRange(){
		const deadline = new Date(this.state.startDate);
		deadline.setFullYear(deadline.getFullYear()+1);
		this.setState({
			activeLoader:     false,
			showSnackBar:     true,
			textSnackBar:     'Debe seleccionar un periodo de tiempo no mayor a 1 año',
			severitySnackBar: 'error',
			startDate:        this.state.startDate,
			finalDate:        formatTime(deadline)
		});
	}

	onDownloadSingleReport(name_report) {
		this.setState({
			activeLoader: true
		});

		let data_to_send = {
			filters: {
				branches:     null,
				initial_date: null,
				final_date:   null,
				vend:         null
			}
		}
		data_to_send[name_report]         = 1;
		data_to_send.filters.initial_date = this.state.startDate;
		data_to_send.filters.final_date   = this.state.finalDate;
		data_to_send.filters.branches     = this.state.branches;
		data_to_send.filters.vend         = this.state.vend;
		Axios.post(process.env.REACT_APP_API_STATISTICS_URL + "/v1/report", data_to_send, {
			responseType: 'arraybuffer',
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `${name_report + '-' + this.state.startDate}.xlsx`);
			document.body.appendChild(link);
			link.click();
			this.setState({
				activeLoader: false
			});
		}, error => {
			this.setState({
				activeLoader: false
			});
		});
	}
	
	onDownloadGeneralReport() {
		this.setState({
			activeLoader: true
		});
		this.forceUpdate();
		let data_to_send = {
			usuario:                          this.state.usuario,
			ventasMonto:                      this.state.ventasMonto,
			ventasTotal:                      this.state.ventasTotal,
			frecuenciaVentas:                 this.state.frecuenciaVentas,
			users_and_device:                 this.state.users_and_device,
			average_tickets:                  this.state.average_tickets,
			users_registered:                 this.state.users_registered,
			users_with_at_least_one_purchase: this.state.users_with_at_least_one_purchase,
			encuestas:                        this.state.encuestas,
			sucursales:                       this.state.sucursales,
			products_out_stock:               this.state.products_out_stock,
			sold_products:                    this.state.sold_products,
			searches:                         this.state.searches,
			most_sold_products:               this.state.most_sold_products,
			average_ticket_line:              this.state.average_ticket_line,
			filters: {
				branches:     null,
				initial_date: null,
				final_date:   null,
				vend:         null
			}
		}
		data_to_send.filters.initial_date = this.state.startDate;
		data_to_send.filters.final_date   = this.state.finalDate;
		data_to_send.filters.branches     = this.state.branches;
		data_to_send.filters.vend         = this.state.vend;
		Axios.post(process.env.REACT_APP_API_STATISTICS_URL + "/v1/report", data_to_send, {
			responseType: 'arraybuffer',
		}).then((response) => {
			const url  = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href  = url;
			link.setAttribute('download', `${'GeneralReport-' + this.state.startDate}.xlsx`);
			document.body.appendChild(link);
			link.click();
			window.URL.revokeObjectURL(link.href);
			this.setState({
				activeLoader: false
			});
		}, error => {
			this.setState({
				activeLoader: false
			});
		});
	}

	onChangeInfoGeneralReport(e) {
		const { id, checked } = e.target;
		if (checked) {
			this.setState({
				[id]: 1,
			});
		} else {
			this.setState({
				[id]: 0,
			});
		}
	}

	addInnerBranchIdToFilters(e) {
		const { id, checked } = e.target;
		let branches = this.state.branches;
		if (checked) {
			branches.push(parseInt(id));
			this.setState({ branches: branches })
		} else {
			let new_array = branches.filter((item) => item !== parseInt(id))
			this.setState({ branches: new_array })
		}
	}

	addVendToFilters(e) {
		const { id, checked } = e.target;
		let vend              = this.state.vend;
		if (checked) {
			vend.push(id);
			this.setState({ vend })
		} else {
			let new_array = vend.filter((item) => item !== id)
			this.setState({ vend: new_array })
		}
	}

	changeTabIndex(tabIndex) {
		this.setState({ tabIndex });
		this.setState({
			activeLoader: true,
		});
		if (tabIndex === 0) {
			setTimeout(() => {
				this.setState({
					activeLoader: false
				});
			}, 2000)
		} else {
			setTimeout(() => {
				this.setState({
					activeLoader: false
				});
			}, 1000)
		}
	}

	handleClick() {
		let value = !this.state.hide_branches
		this.setState({ hide_branches: value });
		if (value === true) {
			this.setState({ branches: [] })
		}
	}

	handleClickVend() {
		let value = !this.state.hide_vend
		this.setState({ hide_vend: value });
		if (value === true) {
			this.setState({ vend: ['IOS', 'ANDROID', 'ECOMMERCE'] })
		}
	}

	handleCloseSnack = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false
		})
	}

	redirectTo() {
		const newWindow = window.open(URL, "_blank", "noopener,noreferrer");
		if (newWindow) newWindow.opener = null;
	}


	///---------------------------------------VIEW-------------------------------------

	render() {
		let startDate = this.state.startDate;
		let finalDate = this.state.finalDate;
		const centros = this.props.centros.centros;
		return (
			<div className="main-content" >
				<div className="malls-category-headers" >
					Descarga de Reportes 
					<IconButton size="small">
						<Info onClick={() => this.redirectTo()} />
					</IconButton>

					<div className="ml-auto w-25 p-3 ">Fecha Inicial<span className="required">*</span>
						<input
							id="startDateForm"
							ref={(el) => {
								this.startDateForm = el;
							}}
							onChange={this.onChangeStartDate.bind(this)}
							value={
								startDate
							}
							type="date"
							className="local-store-input"

						/>
					</div>
					<div className="w-25 p-3 ">Fecha Final<span className="required">*</span>
						<input
							id="finalDateForm"
							type="date"
							className="local-store-input"
							onChange={this.onChangeFinalDate.bind(this)}
							value={
								finalDate
							}
						/>
					</div>

				</div>
				<div className="ml-auto d-inline-block form-control-sm">
					<Form.Check
						defaultChecked
						type="switch"
						id="all_branches"
						label="Todos los centros"
						onClick={this.handleClick}
					/>
				</div>
				<div className="ml-auto d-inline-block form-control-sm">
					<Form.Check
						defaultChecked
						type="switch"
						id="all_vend"
						label="Todas las plataformas"
						onClick={this.handleClickVend}
					/>
				</div>

				<Collapse in={!this.state.hide_branches}>
					<div className="mx-auto  form-control">
						<div className="row justify-content-md-center">
							{centros.map((item, index) => (
								<div key={index} className="ml-3">
									<Form.Check
										type="switch"
										id={item.innerBranchId}
										label={item.clave + "-" + item.nombre}
										onChange={this.addInnerBranchIdToFilters.bind(this)}

									/>
								</div>
							))}
						</div>
					</div>
				</Collapse>

				<Collapse in={!this.state.hide_vend}>
					<div className="mx-auto  form-control">
						<div className="row justify-content-md-center">
							<div key='platform_ios' className="ml-3">
								<Form.Check
									type     = "switch"
									id       = 'IOS'
									label    = 'IOS'
									onChange = {this.addVendToFilters.bind(this)}
								/>
							</div>
							<div key='platform_android' className="ml-3">
								<Form.Check
									type     = "switch"
									id       = 'ANDROID'
									label    = 'ANDROID'
									onChange = {this.addVendToFilters.bind(this)}
								/>
							</div>
							<div key='platform_ecommerce' className="ml-3">
								<Form.Check
									type     = "switch"
									id       = 'ECOMMERCE'
									label    = 'ECOMMERCE'
									onChange = {this.addVendToFilters.bind(this)}

								/>
							</div>
						</div>
					</div>
				</Collapse>

				<div className="user-category-wrapper">
					<Tabs
						selectedIndex={this.state.tabIndex}
						onSelect={tabIndex => this.changeTabIndex(tabIndex)}
						default={true}
						style={{ width: "100%" }}
					>
						<TabList >
							<Tab>Usuarios</Tab>
							<Tab>Pedidos</Tab>
							<Tab>Productos</Tab>
							<Tab>Reporte General</Tab>
						</TabList>
						<TabPanel>
							<Row style={{ width: '100%' }}>
								<Col xs={12} sm={12} md={12} lg={12}>
									<Row className="justify-content-center" style={{ padding: '1rem' }}>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Detalle de usuarios (Histórico)</Card.Header>
												<Card.Header>Filtros aceptados: (N/A)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
													<ButtonGroup size="sm">
														<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('usuario', e)}>
															Descargar Reporte
														</button>
													</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Usuarios registrados (Cantidad)</Card.Header>
												<Card.Header>Filtros aceptados : (Fechas, Centros)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('users_registered', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Usuarios con al menos una compra (Cantidad)</Card.Header>
												<Card.Header>Filtros aceptados : (Fechas, Centros)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('users_with_at_least_one_purchase', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
									</Row>
									<Row className="justify-content-center" style={{ padding: '1rem' }}>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Dispositivos (Versiones)</Card.Header>
												<Card.Header>Filtros aceptados : (N/A)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('users_and_device', e)}>
																Descargar Reporte
															</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Farmacias de usuarios (Listas de precios)</Card.Header>
												<Card.Header>Filtros aceptados : (Fechas, Centros)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('sucursales', e)}>
																Descargar Reporte
															</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Encuesta <i>('Recopilación de datos')</i></Card.Header>
												<Card.Header>Filtros aceptados : (Fechas)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('encuestas', e)}>
																Descargar Reporte
															</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
									</Row>
								</Col>
							</Row>
						</TabPanel>
						<TabPanel >
							<Row style={{ width: '100%' }}>
								<Col xs={12} sm={12} md={12} lg={12}>
									<Row className="justify-content-center" style={{ padding: '1rem' }}>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Pedidos (Montos)</Card.Header>
												<Card.Header>Filtros aceptados : (Fechas, Centros)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('ventasMonto', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Pedidos (Cantidad)</Card.Header>
												<Card.Header>Filtros aceptados : (Fechas, Centros)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('ventasTotal', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={6} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Frecuencia de pedidos</Card.Header>
												<Card.Header>Filtros aceptados : (Fechas, Centros)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('frecuenciaVentas', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
									</Row>
									<Row className="justify-content-center" style={{ padding: '1rem' }}>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Ticket promedio</Card.Header>
												<Card.Header>Filtros aceptados : (Fechas, Centros)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('average_tickets', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Ticket promedio por laboratorio</Card.Header>
												<Card.Header>Filtros aceptados : (Fechas)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('average_ticket_line', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
									</Row>
								</Col>
							</Row>
						</TabPanel>
						<TabPanel>
							<Row style={{ width: '100%' }}>
								<Col xs={12} sm={12} md={12} lg={12}>
									<Row className="justify-content-center" style={{ padding: '1rem' }}>
										<Col xs={12} sm={6} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Productos sin existencia </Card.Header>
												<Card.Header>Filtros aceptados: (Fechas, Centros)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('products_out_stock', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Productos vendidos </Card.Header>
												<Card.Header>Filtros aceptados: (Fechas, Centros, Plataformas)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('sold_products', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Productos más buscados </Card.Header>
												<Card.Header>Filtros aceptados: (Fechas)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('searches', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
									</Row>
									<Row className="justify-content-center" style={{ padding: '1rem' }}>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>El producto más vendido por laboratorio</Card.Header>
												<Card.Header>Filtros aceptados: (Fechas, Centros, Plataformas)</Card.Header>
												<Card.Body>
													<div className="d-flex justify-content-center align-items-center">
														<ButtonGroup size="sm">
															<button className="buttonAdd btn-sm" onClick={(e) => this.onDownloadSingleReport('most_sold_products', e)}>Descargar Reporte</button>
														</ButtonGroup>
													</div>
												</Card.Body>
											</Card>
										</Col>
									</Row>
								</Col>
							</Row>
						</TabPanel>
						<TabPanel>
							<Row style={{ width: '100%' }}>
								<Col xs={12} sm={12} md={12} lg={12}>
									<Row className="justify-content-center" style={{ padding: '1rem' }}>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Usuarios</Card.Header>
													<Card.Body>
														<Form>
															<Form.Check
																type="switch"
																id="usuario"
																label="Detalle de usuarios (Histórico)"
																onChange={this.onChangeInfoGeneralReport.bind(this)}

															/>
															<Form.Check
																type="switch"
																id="users_registered"
																label="Usuarios registrados (Cantidad)"
																onChange={this.onChangeInfoGeneralReport.bind(this)}

															/>
															<Form.Check
																type="switch"
																id="users_with_at_least_one_purchase"
																label="Usuarios con al menos una compra (Cantidad)"
																onChange={this.onChangeInfoGeneralReport.bind(this)}

															/>
															<Form.Check
																type="switch"
																id="users_and_device"
																label="Dispositivos (Versiones)"
																onChange={this.onChangeInfoGeneralReport.bind(this)}
															/>
															<Form.Check
																type="switch"
																id="sucursales"
																label="Farmacias de usuarios (Listas de precios)"
																onChange={this.onChangeInfoGeneralReport.bind(this)}
															/>
															<Form.Check
																type="switch"
																id="encuestas"
																label="Encuesta ('Recopilación de datos')"
																onChange={this.onChangeInfoGeneralReport.bind(this)}
															/>
														</Form>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Pedidos</Card.Header>
												<Card.Body>
													<Form>
														<Form.Check
															type="switch"
															id="ventasMonto"
															label="Pedidos (Montos)"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
														<Form.Check
															type="switch"
															id="ventasTotal"
															label="Pedidos (Cantidad)"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
														<Form.Check
															type="switch"
															id="frecuenciaVentas"
															label="Frecuencia de pedidos"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
														<Form.Check
															type="switch"
															id="average_tickets"
															label="Ticket promedio"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
														<Form.Check
															type="switch"
															id="average_ticket_line"
															label="Ticket promedio por laboratorio"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
													</Form>
												</Card.Body>
											</Card>
										</Col>
										<Col xs={12} sm={12} md={4} lg={4}>
											<Card className="mb-2" border="primary">
												<Card.Header>Productos</Card.Header>
												<Card.Body>
													<Form>
														<Form.Check
															type="switch"
															id="products_out_stock"
															label="Productos sin existencia"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
														<Form.Check
															type="switch"
															id="sold_products"
															label="Productos vendidos"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
														<Form.Check
															type="switch"
															id="searches"
															label="Productos más buscados"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
														<Form.Check
															type="switch"
															id="most_sold_products"
															label="El producto más vendido por laboratorio"
															onChange={this.onChangeInfoGeneralReport.bind(this)}
														/>
													</Form>
												</Card.Body>
											</Card>
										</Col>
									</Row>
								</Col>
							</Row>
							<Row>
								<Col xs={12} sm={12} md={12} lg={12}>
									{
										this.state.activeLoader === false &&
										<Col>
											<button className="buttonAdd ml-auto" onClick={(e) => this.onDownloadGeneralReport(e)}>Descargar Reporte</button>
										</Col>
									}
									{
										this.state.activeLoader === true &&
										<Col>
											<button className="buttonAdd ml-auto" style={buttonDisabled}>Descargar Reporte</button>
										</Col>
									}
								</Col>
							</Row>
						</TabPanel>
					</Tabs>
				</div>
				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text='Esto puede tardar unos minutos'
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)'
							})
						}}>
					</LoadingOverlay>
				}
				{
					<Snackbar
						open={this.state.showSnackBar}
						autoHideDuration={3000}
						onClose={this.handleCloseSnack}>
						<Alert
							onClose={this.handleCloseSnack}
							severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>
		);

	}
}

const mapStateToProps = state => ({
	centros: state.center_reducer,
});

export default connect(
	mapStateToProps,
	{
		getCenters,
	}
)(Statistics);
